import { req } from './axiosCreator'

const service = "/MedOrganizationManagementService"

//获取所有的组织机构
export const getAllMedOrganization = () =>{ return req( 'get', service+"/getAllMedOrganization" )}

